// prettier-ignore
export default {
    "DESCRIPTION": "We and third parties use cookies for technical, measurement and marketing purposes. Thanks to your consent we will be able to improve the user experience, the refusal could make the relative functions unavailable.",
    "POLICY": "Policy",
    "ACCEPT": "Accept",
    "REFUSE": "Refuse"
} as const